// Lazy delegate for the imperative report-entity dialog opener.
//
// Same shape and same reason as `ReportUserDialogLazy`: `ReportEntityDialog` drags in the attachment
// picker and the request-validation module, and the chat surface would otherwise pay for all of it on
// every conversation open just to offer a menu item most members never use. Routing the opener through
// here loads it the first time somebody actually reports something.
//
// Goes through `importChunkWithRetryAndReload` rather than a bare `import()` (AGENTS.md rule 26): a bare
// dynamic import has no recovery, and a stale `main_bundle.js` referencing a chunk hash the origin no
// longer serves would leave the click doing nothing at all, with no error boundary able to see it.

import type { Localizer } from "@/main/react/Types";
import { importChunkWithRetryAndReload } from "@/lib/lazyWithRetry";
import type { ReportableEntityType } from "@/main/common/ModerationReportApi";

export function showReportEntityDialog(
    localizer: Localizer,
    entityType: ReportableEntityType,
    publicId: string,
    onSuccess?: () => void,
) {
    void importChunkWithRetryAndReload(
        () => import("@/main/react/Dialog/ReportEntityDialog").then((m) => ({ default: m.showReportEntityDialog })),
        "report-entity-dialog",
    ).then((m) => m.default(localizer, entityType, publicId, onSuccess));
}
